import { DialogProgrammatic } from 'buefy';
import { BaseUIService } from '/@/modules/core/ui/services/BaseUIService';
import type { App } from 'vue';

let dialogInstance: DialogProgrammatic | null = null;

// Type definition for Buefy Vue 3
interface BDialogConfig {
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  type?: string;
  hasIcon?: boolean;
  icon?: string;
  iconPack?: string;
  animation?: string;
  canCancel?: boolean | string[];
  onConfirm?: () => void;
  onCancel?: () => void;
  [key: string]: unknown;
}

export class DialogService extends BaseUIService {
  setApp(app: App): void {
    dialogInstance = new DialogProgrammatic(app);
  }

  confirm(options?: BDialogConfig): void {
    if (!dialogInstance) {
      throw new Error('DialogService: app not initialized. Call setApp() first.');
    }
    dialogInstance.confirm(options);
  }
}

export default new DialogService();
